/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Selector } from '../../components';
import { fetchSurveysByTenant } from '../../stores/actions/surveys';
import { isNullOrEmptyArray } from '../../util/arrays';
import { setActiveClient, setActiveSurvey, setActiveQuestion } from '../../stores/actions/activeSurvey';
import * as Ui from './styles';

const propTypes = {
  tenants: PropTypes.array,
  isAdmin: PropTypes.bool,
  isEmployee: PropTypes.bool,
  isCustomer: PropTypes.bool,
  maximizedCard: PropTypes.string,
  onSelect: PropTypes.func,
  onMaximize: PropTypes.func,
  onMinimize: PropTypes.func,
  theme: PropTypes.object.isRequired,
};

const defaultProps = {
  tenants: [],
  isAdmin: false,
  isEmployee: false,
  isCustomer: false,
  maximizedCard: null,
  onSelect: null,
  onMaximize: null,
  onMinimize: null,
};

function GroupSelectors(props) {
  // props from redux
  const { dispatch, running, error, surveysProps, activeSurvey } = props;
  // props from parent component
  const {
    tenants,
    isAdmin,
    isEmployee,
    isCustomer,
    onSelect,
    theme,
  } = props;


  // states
  const [customers, setCustomers] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [questions, setQuestions] = useState([]);

  // initialize customer
  const initialize = useCallback((cId) => {
    // set customer
    setActiveClient({ id: cId }, dispatch);
    setActiveSurvey(null, dispatch);
    setActiveQuestion(null, dispatch);
    // fetch surveys by tenant
    fetchSurveysByTenant(cId, dispatch);
  }, [dispatch]);

  // fethed tenants effect
  useEffect(() => {
    setCustomers(tenants.map((item) => (
      { label: item.nome, value: item.id }
    )));
  }, [tenants]);

  // select customer default on customer token
  useEffect(() => {
    // is a valid customer
    const isCustomerValid = isCustomer
      && !isNullOrEmptyArray(customers)
      && customers[0]
      && customers[0].value;
    // if is valid customer, select default
    if (isCustomerValid) {
      initialize(customers[0].value);
    }
  }, [initialize, customers, isCustomer]);

  // fethed tenants effect
  useEffect(() => {
    const newSurveys = surveysProps.map((item) => (
      { label: item.titulo, value: item.id }
    ));
    setSurveys(newSurveys);
    setQuestions([]);
  }, [surveysProps]);

  // error effect
  useEffect(() => {
    if (error) {
      toast.warn('Esse cliente ainda não possui avaliações');
    }
  }, [error]);


  // handle on change tentant
  function handleChangeOptionTenants(options) {
    // does nothing
    if (isNullOrEmptyArray(options)) return;
    // first value
    const { value } = options[0];
    // set customer
    setActiveSurvey(null, dispatch);
    setActiveQuestion(null, dispatch);
    setActiveClient({ id: value }, dispatch);
    // fetch surveys by tenant
    fetchSurveysByTenant(value, dispatch);
  }

  // handle on change survey
  function handleChangeOptionSurvey(options) {
    // does nothing
    if (isNullOrEmptyArray(options)) return;
    // first value
    const { value, label } = options[0];
    // set survey
    const survey = {
      id: value,
      titulo: label,
    };
    setActiveSurvey(survey, dispatch);
    setActiveQuestion(null, dispatch);
    // fetch questions
    retrieveQuestionsBySurvey(value);
  }

  // handle on change survey
  function handleChangeOptionQuestion(options) {
    // does nothing
    if (isNullOrEmptyArray(options)) return;
    // set survey
    setActiveQuestion({
      id: options[0].value,
      enunciado: options[0].label,
    }, dispatch);
    // fire event
    if (onSelect) onSelect(activeSurvey.client.id, activeSurvey.survey.id, activeSurvey.question);
  }

  function retrieveQuestionsBySurvey(value) {
    surveysProps.map((item) => {
      if (value === item.id) {
        const questionsArr = item.perguntas
          /**
           * sorting by question's "ordem" field
           */
          .sort((first, second) => first.ordem - second.ordem)
          /**
           * mapping question to selector item
           */
          .map((subItem) => (
            { label: subItem.enunciado, value: subItem.id }
          ));
        setQuestions(questionsArr);
      }
      return item;
    });
  }

  return (
    <Ui.Container>
      <Ui.GroupSection className="inputs" totalItens={isAdmin || isEmployee ? 3 : 2}>
        {/* 1st combo */}
        {isAdmin || isEmployee ? (
          <div className="container">
            <Ui.ThemeAware theme={theme}>
              <Selector
                type="single"
                placeholder="Selecione o cliente"
                inputSearchPlaceholder="Busque pelo nome de um cliente"
                data={customers}
                onChange={handleChangeOptionTenants}
                enableFilter
              />
            </Ui.ThemeAware>
          </div>
        ) : (
          ''
        )}
        {/* 2nd combo */}
        <div className="container">
          <Ui.ThemeAware theme={theme}>
            <Selector
              type="single"
              placeholder="Selecione uma avaliação"
              inputSearchPlaceholder="Busque pelo título de uma avaliação"
              data={surveys}
              isLoading={running}
              onChange={handleChangeOptionSurvey}
              enableFilter
            />
          </Ui.ThemeAware>
        </div>
        {/* 3nd combo */}
        <div className="container">
          <Ui.ThemeAware theme={theme}>
            <Selector
              type="single"
              placeholder="Selecione uma pergunta"
              inputSearchPlaceholder="Busque pelo enunciado de uma pergunta"
              data={questions}
              isLoading={running}
              onChange={handleChangeOptionQuestion}
              enableFilter
            />
          </Ui.ThemeAware>
        </div>
      </Ui.GroupSection>
    </Ui.Container>
  );
}

GroupSelectors.propTypes = propTypes;
GroupSelectors.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const surveysState = state.surveys;
  const { activeSurvey } = state;
  return {
    running: surveysState.running,
    error: surveysState.error,
    surveysProps: surveysState.payload,
    activeSurvey,
  };
};

export default connect(mapStateToProps)(GroupSelectors);
